import { NavLink, Outlet, useParams } from "react-router-dom";
import { FolderGit2, Settings } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Two-column shell for the org-scoped area (`/orgs/:org`, `/orgs/:org/settings/*`,
 * `/orgs/:org/trash`) — a left sidebar (Projects / Settings) + content.
 * Deliberately does NOT wrap `/orgs/:org/projects/:project/*` — those keep
 * ProjectLayout's own tab nav, unchanged.
 */
export function OrgLayout() {
  const { org } = useParams<{ org: string }>();

  const ITEMS = [
    { to: `/orgs/${org}`, label: "Projects", icon: FolderGit2, end: true },
    { to: `/orgs/${org}/settings`, label: "Settings", icon: Settings, end: false },
  ];

  return (
    // Sidebar on md+; on mobile it collapses to a horizontal pill row so
    // content keeps the full width.
    <div className="flex flex-col md:flex-row min-h-[calc(100vh-3rem)]">
      <nav className="w-full md:w-48 shrink-0 border-b md:border-b-0 md:border-r border-border-muted px-3 py-2 md:py-6 flex md:flex-col gap-1 md:gap-0 md:space-y-0.5 overflow-x-auto scrollbar-none">
        {ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              cn(
                "flex shrink-0 items-center gap-2 h-8 px-2.5 rounded-md text-sm whitespace-nowrap text-muted-foreground transition-colors",
                "hover:bg-subtle hover:text-foreground",
                isActive && "bg-subtle text-foreground font-semibold",
              )
            }
          >
            <item.icon className="h-3.5 w-3.5" />
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
